/**
 * CustomerSupport - Footer customer support section
 *
 * Data from centralized config (lib/footerConfig.ts)
 */

import { FooterLinkSection } from './FooterLinkSection'
import { customerSupportSection } from '../../lib'

export function CustomerSupport() {
  return <FooterLinkSection data={customerSupportSection} />
}
